import axiosInstance from './axios';
import { LoginRequest, JwtAuthenticationResponse, User } from '../types/auth.types';

/**
 * 인증 관련 API
 */
export const authApi = {
  /**
   * 로그인
   */
  login: async (loginRequest: LoginRequest): Promise<JwtAuthenticationResponse> => {
    const response = await axiosInstance.post<JwtAuthenticationResponse>(
      '/api/auth/login',
      loginRequest
    );
    return response.data;
  },

  /**
   * 로그아웃
   */
  logout: async (): Promise<void> => {
    await axiosInstance.post('/api/auth/logout');
  },

  /**
   * 현재 사용자 정보 조회
   */
  getCurrentUser: async (): Promise<User> => {
    const response = await axiosInstance.get<User>('/api/auth/me');
    return response.data;
  },

  /**
   * 토큰 갱신
   */
  refreshToken: async (refreshToken: string): Promise<JwtAuthenticationResponse> => {
    const response = await axiosInstance.post<JwtAuthenticationResponse>(
      '/api/auth/refresh',
      {},
      {
        headers: {
          'Refresh-Token': refreshToken,
        },
      }
    );
    return response.data;
  },
};
